import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
} from "@ofqual/portal-core/core/types";

export class InformationRequestService extends BaseRemoteService {
  public async create(opts: Opts): Promise<string> {
    const url = `${this.apiRoot}/informationrequests`;
    const { id } = await super.postRequest<{ id: string }>(url, null, opts);
    return id;
  }
}
